export enum PAGE_EXIT_STATE {
  ABORTED = 1,
  FAILED = 2,
  SUCCESS = 3,
}

export enum AuthenticationSource {
  Login = 'login',
  Signup = 'signup',
}

export enum EnableBiometricsAction {
  EnableBiometrics = 0,
  SetupLater = 1,
}

export enum AuthMethod {
  ShopeeOAuth = 1,
}

export const RELOGIN_INFO_LOCAL_STORAGE_KEY = 'userInfo';

export const DEFAULT_BRIDGE_TIMEOUT = 5000; // ms
